import React, { ReactNode, useState } from "react";
import { Category } from "../../types/types";
import useMediaQuery from "../../hooks/useMediaQuery";
import mainContentLayoutStyles from "./mainContentLayout.module.css";
import Sidebar from "../sidebar/sidebar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  userSelector,
  activeContactSelector,
  isContactSessionSelector,
  linkedClientsSelector,
  activeContactTokenSelector
} from "../../services/selectors/user.selectors";
import { useAppSelector } from "../../services/hooks";
import { useActions } from "../../services/hooks/useActions";
// import Notifications from "../notifications/notifications";
import { menuTitles } from "../../utils/categories";
import { mobileWidth } from "../../utils/constants";
import ModalOverlay from "../modals/modalOverlay/ModalOverlay";
import { tWithKeyAttr as t } from "../../i18nHelper";
import i18n from "../../i18n";
import CompaniesCombo from "../companiesCombo/CompaniesCombo";

interface IMainContentLayoutProps {
  activeCategory: Category;
  changeCategory: (e: React.MouseEvent, cat: Category) => void;
  children: ReactNode;
}

function MainContentLayout({
  activeCategory,
  changeCategory,
  children,
}: IMainContentLayoutProps) {
  const mobile = useMediaQuery(mobileWidth);
  const initialState = !mobile;
  const location = useLocation();

  const navigate = useNavigate();
  const linkedClients = useAppSelector(linkedClientsSelector);

  const user = useAppSelector(userSelector);
  const isContactSession = useAppSelector(isContactSessionSelector);


  const { logout } = useActions();
  const [openMenu, setOpenMenu] = useState(initialState);
  const [showNotifications, setShowNotifications] = useState(false);

  const isPrevencher = location.pathname === "/prevencher";
  const isForum = location.pathname === "/forum" || location.pathname.startsWith("/forum/");

  const toggleMenu = () => {
    setOpenMenu(!openMenu);
  };
  const hideNotifications = () => {
    if (showNotifications) setShowNotifications(false);
  };

  return (
    <main
      className={`${mainContentLayoutStyles.main} ${mobile && openMenu && "lock-scroll"
        }`}
    >
      {mobile && openMenu && (
        <ModalOverlay onClick={() => setOpenMenu(false)} />
      )}
      <section dir={i18n.dir()}
        className={`${mainContentLayoutStyles.mainContent} ${isPrevencher && mainContentLayoutStyles.mainContent_noScroll
          }`}
        onClick={hideNotifications}
        data-testid="home-section"
      >
        {/*<Notifications showNotifications={showNotifications} />*/}
        <div
          className={`${mainContentLayoutStyles.header} ${isPrevencher && mainContentLayoutStyles.header_prevencher
            } ${isForum && mainContentLayoutStyles.header_forum}`}
        >
          <div className={mainContentLayoutStyles.leftHeaderControls}>
            {(user.usersMultipleCompanies 
              && user.usersMultipleCompanies?.length > 1) 
              && <CompaniesCombo />}
            {/* <button
              className={`${mainContentLayoutStyles.mainContent__bell} ${(showNotifications || (isForum && !mobile) || isPrevencher) &&
                mainContentLayoutStyles.mainContent__bell_invisible
                }`}
              onClick={() => {
                // setShowNotifications(!showNotifications);
              }}
            /> */}
          </div>
          {isPrevencher && (
            <Link
              to={"/home"}
              className={mainContentLayoutStyles.link}
              onClick={(e) => changeCategory(e, Category.Day)}
            >
              {t('CLOSE_CHAT')}
            </Link>
          )}
          <h1 className={`${mainContentLayoutStyles.mainContent__title}`}>
            {isForum ? t('FORUM') : t(menuTitles[activeCategory])}
          </h1>
          <button
            type="button"
            onClick={toggleMenu}
            className={mainContentLayoutStyles.burger}
          />
        </div>
        {children}
      </section>

      {/* Floating contact session indicator */}
      {/* Floating contact session indicator */}
      {isContactSession && (
        <div dir={i18n.dir()} className={mainContentLayoutStyles.contactIndicator}>
          <span className={mainContentLayoutStyles.contactIndicatorText}>
            {t('VIEWING_AS')} {user.fullName}
          </span>
          {linkedClients && linkedClients.length > 1 && (
            <button
              className={mainContentLayoutStyles.contactIndicatorButton}
              onClick={() => navigate('/select-patient')}
              aria-label="Switch Patient"
            >
              {t('SWITCH_PATIENT') || 'Switch Patient'}
            </button>
          )}
          <button
            className={mainContentLayoutStyles.contactIndicatorButton}
            onClick={() => logout()}
            aria-label="Exit viewing"
          >
            {t('EXIT') || 'Exit'}
          </button>
        </div>
      )}


      <Sidebar
        changeCategory={changeCategory}
        activeCategory={activeCategory}
        openMenu={openMenu}
        toggleMenu={toggleMenu}
      />
    </main>
  );
}
export default MainContentLayout;
